/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
import React from 'react';
import { AiFillStar } from 'react-icons/ai';
import { motion } from 'framer-motion';
// import swLogo from '../../../assets/icons/SW LOgo 1.svg'
import swLogo from '../assets/icons/SW LOgo 1.svg';

function Testimonial({
  title = '', subtitle = '', text = '', author = {}, redirect = '', videoSrc = '', stars = 4,
}) {
  return (
    <>
      <div
        key={`${title}-video`}
        className="relative flex justify-center items-center min-h-[20rem]"
      >
        {/* ----images layer----- */}
        <div className="absolute h-full w-full">
          <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8aGVhZCUyMHByb2ZpbGVzfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60" alt="author" className="rounded-lg h-[4rem] w-[4rem] object-cover absolute top-[20%] left-[13%] rotate-[0deg]" />
          <img src="https://images.unsplash.com/photo-1602233158242-3ba0ac4d2167?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Z2lybHxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60" alt="author" className="rounded-lg h-[4rem] w-[4rem] object-cover absolute top-[5%] left-[30%]" />
          <img src="https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8aGVhZCUyMHByb2ZpbGVzfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60" alt="author" className="rounded-lg h-[4rem] w-[4rem] object-cover absolute top-0 right-[20%]" />
          <img src="https://images.unsplash.com/photo-1667053508464-eb11b394df83?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fGhlYWQlMjBwcm9maWxlc3xlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60" alt="author" className="rounded-lg h-[3rem] w-[3rem] object-cover absolute top-[30%] right-[10%] rotate-[0deg] shadow-lg" />
          <img src="https://images.unsplash.com/photo-1555760113-2ff3079217cc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8aGVhZCUyMHByb2ZpbGVzfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60" alt="author" className="rounded-lg h-[4rem] w-[4rem] object-cover absolute bottom-[4%] right-[40%] shadow-lg" />
          <img src="https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fGhlYWQlMjBwcm9maWxlc3xlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60" alt="author" className="rounded-lg h-[5rem] w-[5rem] object-cover absolute bottom-[10%] left-[16%]  shadow-lg" />
          <img src="https://images.unsplash.com/photo-1620122303020-87ec826cf70d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjB8fGhlYWR8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=500&q=60" alt="author" className="rounded-lg h-[5rem] w-[5rem] object-cover absolute bottom-[10%] right-[16%]  shadow-lg" />
        </div>

        {/* ----video layer----- */}
        <motion.video
          poster={swLogo}
          src={videoSrc || 'https://player.vimeo.com/progressive_redirect/playback/725952347/rendition/1080p/file.mp4?loc=external&signature=57a7c3522f4c7c21f8123a490b67c603be4efaa02c9c70cfde99789ab3ea9a29'}
          muted
          autoPlay
          playsInline
          loop
          controls
          className="border-4 border-white bg-dark-500 rounded-lg w-full md:w-[70%] aspect-video relative z-20 object-cover drop-shadow-lg"
        >
          J
        </motion.video>
      </div>

      <motion.div
        key={`${title}-content`}
        onClick={() => window.open(redirect)}
      >
        <motion.h1
          animate={{
            y: [30, 0],
            opacity: [0.5, 1],
            transition: {
              duration: 1,
            },
          }}
          className="text-xl leading-tight"
        >
          { title || 'Meet Client Satisfaction after working with us'}

        </motion.h1>
        <motion.div
          animate={{
            y: [30, 0],
            opacity: [0, 1],
            transition: {
              delay: 0.3,
              duration: 0.7,
            },
          }}
          className="mt-[1.7rem] mb-[1rem]"
        >
          <h4 className="font-semibold text-lg">{ subtitle || 'Doesn’t feel like an agency'}</h4>
          <div className="mt-2 flex items-center gap-1 text-lg">
            {
            Array(stars).fill('0').map((el, i) => (
              <motion.span
                key={`${title}-star-${i}`}
                animate={{
                  x: [-30, 0],
                  rotate: [30, 0],
                  transition: {
                    delay: i * 0.2,
                    duration: 1,
                  },
                }}
              >
                <AiFillStar className="text-yellow-500" />
              </motion.span>
            ))
          }
          </div>
        </motion.div>

        <motion.p
          animate={{
            y: [30, 0],
            opacity: [0, 1],
            transition: {
              delay: 0.5,
              duration: 0.7,
            },
          }}
          className="text-dark-300"
          dangerouslySetInnerHTML={{ __html: text }}
        />

        <div className="mt-[2rem]">
          {/* --avatar---- */}
          <motion.div
            animate={{
              y: [30, 0],
              opacity: [0, 1],
              transition: {
                delay: 0.6,
                duration: 0.7,
              },
            }}
            className="flex gap-2 items-center"
          >
            <img src={author.picture} alt="author" className="rounded-[1rem] h-[3rem] w-[3rem] object-cover" />
            <div>
              <p className="font-semibold capitalize">{author?.name}</p>
              <p className="text-dark-300">{author?.company}</p>
            </div>
          </motion.div>
        </div>
      </motion.div>
    </>
  );
}

export default Testimonial;
